import React from 'react';
import {
  Gauge, DollarSign, TrendingUp, Users, Filter, Target, UserCheck, Crosshair, Briefcase, MapPin, Globe,
  ClipboardCheck, Megaphone, Handshake, Clock, Wallet, Shield, Swords, Building2, ExternalLink, BarChart3, CheckCircle2,
} from 'lucide-react';
import { ReportBlocks, PdfButton } from '../report/ReportBlocks';

const ICONS = {
  executive_summary: Gauge, salary_analysis: DollarSign, market_demand: TrendingUp, talent_supply: Users,
  talent_pool_funnel: Filter, skills_analysis: Target, ideal_candidate_profile: UserCheck, target_talent_sources: Crosshair,
  similar_job_titles: Briefcase, nearby_markets: MapPin, top_hiring_locations: Globe, screening_scorecard: ClipboardCheck,
  candidate_value_proposition: Megaphone, offer_strategy: Handshake, interview_market_intel: Clock,
  compensation_deep_dive: Wallet, retention_intelligence: Shield, competitive_landscape: Swords,
  companies_hiring_similar: Building2, top_staffing_companies: Briefcase, companies_with_job_links: ExternalLink,
  location_specific_insights: MapPin, diversity_insights: Users, hiring_trends: BarChart3, recommendations: CheckCircle2,
};

const when = (iso) => (iso ? new Date(iso).toLocaleString(undefined, { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : '');

// One Market Intelligence report view for the job page, shared links and the combined share
export const MIReportView = ({ data, pdfUrl, actions, showHeader = true }) => (
  <div className="space-y-6" data-testid="mi-report-display">
    {showHeader && (
      <div className="flex items-start justify-between flex-wrap gap-3">
        <div>
          <h3 className="text-lg font-bold" style={{ fontFamily: 'Manrope, sans-serif' }}>Market Intelligence Report</h3>
          <p className="text-xs text-muted-foreground" data-testid="mi-report-meta">
            {[data.job_title, data.job_location, data.created_at && `Generated ${when(data.created_at)}`].filter(Boolean).join(' · ')}
          </p>
        </div>
        <div className="flex gap-2 flex-wrap">
          {actions}
          {pdfUrl && <PdfButton url={pdfUrl} testid="mi-download-pdf" />}
        </div>
      </div>
    )}
    {data.view?.length ? <ReportBlocks view={data.view} icons={ICONS} testid="mi-report-blocks" /> : (
      <p className="text-sm text-muted-foreground" data-testid="mi-report-empty">This report has no data yet.</p>
    )}
  </div>
);

export default MIReportView;
